import React, { useState } from "react";
import { Table, Card, Space, Button, Modal, Radio, Tabs } from "antd";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const vitalsKeys = [
  "bpSystolic",
  "bpDiastolic",
  "heartRate",
  "bodyTemperature",
  "bmi",
];

const VitalsTab = ({ vitals }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [viewRange, setViewRange] = useState("day"); // day/week/month
  const [activeTab, setActiveTab] = useState("table"); // table/chart

  const handleView = (record) => {
    setSelectedRecord(record);
    setModalVisible(true);
  };

  const getFilteredVitals = () => {
    // TODO: implement aggregation by day/week/month
    return vitals;
  };

  const filteredVitals = getFilteredVitals();

  const getChartData = (key) => {
    const data = filteredVitals.map((v) => Number(v[key]?.value || 0));
    const colors = filteredVitals.map((v) =>
      v[key]?.criticality === "critical" ? "red" : "green"
    );

    return {
      labels: filteredVitals.map((v) => v.createdOn),
      datasets: [
        {
          label: key,
          data,
          borderColor: colors,
          backgroundColor: colors,
          tension: 0.3,
        },
      ],
    };
  };

  const chartOptions = {
    responsive: true,
    plugins: { legend: { display: true } },
    scales: { y: { beginAtZero: false } },
    maintainAspectRatio: false,
  };

  const columns = [
    { title: "Date", dataIndex: "createdOn", key: "createdOn" },
    {
      title: "BP (Sys/Dia)",
      render: (_, r) => `${r.bpSystolic?.value}/${r.bpDiastolic?.value}`,
    },
    { title: "Heart Rate", render: (_, r) => r.heartRate?.value },
    { title: "BMI", render: (_, r) => r.bmi?.value },
    { title: "Temperature", render: (_, r) => r.bodyTemperature?.value },
    {
      title: "Actions",
      render: (_, r) => <Button onClick={() => handleView(r)}>View</Button>,
    },
  ];

  return (
    <Card>
      {/* <Table
        columns={columns}
        dataSource={vitals}
        rowKey={(r) => r.vitalId}
        pagination={false}
        bordered
      /> */}

      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        type="card"
      >
        <Tabs.TabPane tab="Table" key="table">
          <Table
            columns={columns}
            dataSource={vitals}
            rowKey={(r) => r.vitalId}
            pagination={false}
            bordered
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Charts" key="chart">
          <Space style={{ marginBottom: 20 }}>
            <Radio.Group
              value={viewRange}
              onChange={(e) => setViewRange(e.target.value)}
            >
              <Radio.Button value="day">Day</Radio.Button>
              <Radio.Button value="week">Week</Radio.Button>
              <Radio.Button value="month">Month</Radio.Button>
            </Radio.Group>
          </Space>

          <Card title="Vitals Charts">
            <Space direction="vertical" style={{ width: "100%" }}>
              {vitalsKeys.map((key) => (
                <div key={key} style={{ marginBottom: 20 }}>
                  <h4>{key}</h4>
                  <div style={{ height: 200 }}>
                    <Line data={getChartData(key)} options={chartOptions} />
                  </div>
                </div>
              ))}
            </Space>
          </Card>
        </Tabs.TabPane>
      </Tabs>

      <Modal
        title="Vitals Detail"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        width={1200}
        footer={null}
        styles={{
          body: { maxHeight: "80vh", overflowY: "auto", padding: "20px" },
        }}
        style={{ top: 20 }}
      >
        {selectedRecord && (
          <Card title="Vitals Charts">
            <Space direction="vertical" style={{ width: "100%" }}>
              {vitalsKeys.map((key) => (
                <div key={key} style={{ marginBottom: 20 }}>
                  <h4>{key}</h4>
                  <div style={{ height: 200 }}>
                    <Line data={getChartData(key)} options={chartOptions} />
                  </div>
                </div>
              ))}
            </Space>
          </Card>
        )}
      </Modal>
    </Card>
  );
};

export default VitalsTab;
